// Lang.js only knows real ISO plural-rule families. GreenMotion sets Lang's locale to its own
// site/domain codes (see SetLocale.php), several of which aren't ISO codes and fall through to
// Lang.js's default plural rule (always singular). Map those to an equivalent ISO code so
// Lang.choice() picks the right plural form.
const PLURAL_RULE_LOCALE_MAP = {
    'en-us': 'en',
    gr: 'el',
    cn: 'zh',
    tw: 'zh',
    mx: 'es',
    se: 'sv',
    dk: 'da',
    ba: 'bs',
    me: 'sr',
    rs: 'sr',
    jp: 'ja',
};

export default {
    methods: {
        trans(key, replacements = {}, locale = null) {
            if (window['gmtrans']) {
                return gmtrans(key, replacements, locale);
            }
        },
        transChoice(key, number, replacements = {}, locale = null) {
            const currentLocale = Lang.getLocale();
            const pluralRuleLocale = PLURAL_RULE_LOCALE_MAP[locale || currentLocale];

            if (!pluralRuleLocale || pluralRuleLocale === currentLocale) {
                return Lang.choice(key, number, replacements, locale);
            }

            Lang.setLocale(pluralRuleLocale);
            try {
                return Lang.choice(key, number, replacements, locale);
            } finally {
                Lang.setLocale(currentLocale);
            }
        },
    },
};
